    <div class="container-fluid">
        <div class="row mt-4">
            <div class="col">
                <h5 class="blue"><i class="fas fa-money-bill-transfer"></i>&nbsp;Precios de combustibles</h5>
            </div>
        </div>
        <hr style="margin-bottom: 0px;">
        <div class="container-fuid" style="height: 550px; overflow-y: auto;  overflow-x: hidden; ">
            <mat-tab-group animationDuration="0ms">
                <mat-tab [label]="precios[0].tipo">
                    <app-precio-contenido [formContent]="precios[0]" (responseContent)="responseContent($event)"></app-precio-contenido>
                </mat-tab>
                <mat-tab [label]="precios[1].tipo">
                    <app-precio-contenido [formContent]="precios[1]" (responseContent)="responseContent($event)"></app-precio-contenido>
                </mat-tab>
                <mat-tab [label]="precios[2].tipo">
                    <app-precio-contenido [formContent]="precios[2]" (responseContent)="responseContent($event)"></app-precio-contenido>
                </mat-tab>
            </mat-tab-group>
        </div>
    </div>